import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { QuoteActionTypes, GetQuoteListSuccess, GetQuoteListFailure, GetQuoteSuccess, GetQuoteFailure, CreateRentalQuoteFailure, 
  CreateRentalQuoteSuccess, CreatePurchaseQuoteFailure, CreatePurchaseQuoteSuccess, GetCustomerQuoteListFailure, 
  GetCustomerQuoteListSuccess, GetSalesQuoteListSuccess, GetSalesQuoteListFailure, UpdateQuoteSuccess, UpdateQuoteFailure, 
  DownloadQuoteSuccess, DownloadQuoteFailure, EmailQuoteSuccess, EmailQuoteFailure, 
  DownloadPurchaseQuoteSuccess, DownloadPurchaseQuoteFailure, EmailPurchaseQuoteFailure, EmailPurchaseQuoteSuccess, EmailReportSuccess, EmailReportFailure
} from "../actions/quote.action";
import { KwikspaceService } from 'src/app/services/kwikspace.service';

@Injectable()
export class QuoteEffects {
  public constructor(
    private actions$: Actions,
    private service: KwikspaceService
  ) { }

  @Effect()
  GetQuoteList$: Observable<any> = this.actions$.pipe(
    ofType(QuoteActionTypes.GET_QUOTE_LIST),
    switchMap((action: any) => {
      return this.service.getQuoteList(action.payload).pipe(
        map((res: any) => new GetQuoteListSuccess(res)),
        catchError((error) => of(new GetQuoteListFailure(error)))
      );
    })
  );

  @Effect()
  GetCustomerQuoteList$: Observable<any> = this.actions$.pipe(
    ofType(QuoteActionTypes.GET_CUSTOMER_QUOTE_LIST),
    switchMap((action: any) => {
      return this.service.getCustomerQuoteList(action.payload).pipe(
        map((res: any) => new GetCustomerQuoteListSuccess(res)),
        catchError((error) => of(new GetCustomerQuoteListFailure(error)))
      );
    })
  );

  @Effect()
  GetSalesQuoteList$: Observable<any> = this.actions$.pipe(
    ofType(QuoteActionTypes.GET_SALES_QUOTE_LIST),
    switchMap((action: any) => {
      return this.service.getSalesQuoteList(action.payload).pipe(
        map((res: any) => new GetSalesQuoteListSuccess(res)),
        catchError((error) => of(new GetSalesQuoteListFailure(error)))
      );
    })
  );

  @Effect()
  GetQuote$: Observable<any> = this.actions$.pipe(
    ofType(QuoteActionTypes.GET_QUOTE),
    switchMap((action: any) => {
      return this.service.getQuoteById(action.id).pipe(
        map((res: any) => new GetQuoteSuccess(res)),
        catchError((error) => of(new GetQuoteFailure(error)))
      );
    })
  );

  @Effect()
  DownloadQuote$: Observable<any> = this.actions$.pipe(
    ofType(QuoteActionTypes.DOWNLOAD_QUOTE),
    switchMap((action: any) => {
      return this.service.downloadQuote(action.id).pipe(
        map((res: any) => new DownloadQuoteSuccess(res)),
        catchError((error) => of(new DownloadQuoteFailure(error)))
      );
    })
  );
  
  @Effect()
  EmailQuote$: Observable<any> = this.actions$.pipe(
    ofType(QuoteActionTypes.EMAIL_QUOTE),
    switchMap((action: any) => {
      return this.service.sendQuoteEmail(action.quoteId).pipe(
        map((res: any) => new EmailQuoteSuccess(res)),
        catchError((error) => of(new EmailQuoteFailure(error)))
      );
    })
  );
  
  @Effect()
  EmailReport$: Observable<any> = this.actions$.pipe(
    ofType(QuoteActionTypes.EMAIL_REPORT),
    switchMap((action: any) => {
      return this.service.sendReportEmail().pipe(
        map((res: any) => new EmailReportSuccess(res)),
        catchError((error) => of(new EmailReportFailure(error)))
      );
    })
  );

  @Effect()
  DownloadPurchaseQuote$: Observable<any> = this.actions$.pipe(
    ofType(QuoteActionTypes.DOWNLOAD_PURCHASE_QUOTE),
    switchMap((action: any) => {
      return this.service.downloadPurchaseQuote(action.id).pipe(
        map((res: any) => new DownloadPurchaseQuoteSuccess(res)),
        catchError((error) => of(new DownloadPurchaseQuoteFailure(error)))
      );
    })
  );


  @Effect()
  EmailPurchaseQuote$: Observable<any> = this.actions$.pipe(
    ofType(QuoteActionTypes.EMAIL_PURCHASE_QUOTE),
    switchMap((action: any) => {
      return this.service.sendPurchaseQuoteEmail(action.quoteId).pipe(
        map((res: any) => new EmailPurchaseQuoteSuccess(res)),
        catchError((error) => of(new EmailPurchaseQuoteFailure(error)))
      );
    })
  );

  @Effect()
  CreateRentalQuote$: Observable<any> = this.actions$.pipe(
    ofType(QuoteActionTypes.CREATE_RENTAL_QUOTE),
    switchMap((action: any) => {
      return this.service.createQuote(action.payload).pipe(
        map((res: any) => new CreateRentalQuoteSuccess(res)),
        catchError((error) => of(new CreateRentalQuoteFailure(error)))
      );
    })
  );

  @Effect()
  CreatePurchaseQuote$: Observable<any> = this.actions$.pipe(
    ofType(QuoteActionTypes.CREATE_PURCHASE_QUOTE),
    switchMap((action: any) => {
      return this.service.createQuote(action.payload).pipe(
        map((res: any) => new CreatePurchaseQuoteSuccess(res)),
        catchError((error) => of(new CreatePurchaseQuoteFailure(error)))
      );
    })
  );

  @Effect()
  UpdateQuote$: Observable<any> = this.actions$.pipe(
    ofType(QuoteActionTypes.UPDATE_QUOTE),
    switchMap((action: any) => {
      return this.service.updateQuote(action.payload, action.id).pipe(
        map((res: any) => new UpdateQuoteSuccess(res)),
        catchError((error) => of(new UpdateQuoteFailure(error)))
      );
    })
  );

}
